import BaseAPI from "@/apis/base/BaseAPI.js";
import BaseAPIConfig from "@/apis/base/BaseAPIConfig.js";

class UserRoleAPI extends BaseAPI {
  constructor() {
    super();
    this.controller = "UserRoles";
  }

  /**
   * lấy paging danh sách user
   * pmhieu 2021.08.26 
   * @param {} paging 
   * @returns 
   */
  getUserPagingByAppCode(paging) {
    return BaseAPIConfig.post(this.controller + "/UserPaging", paging);
  }

  /**
   * lấy paging danh sách user
   * NVHa1 18/01/2022
   * @param {} paging 
   * @returns 
   */
  getAllUserRoleApp(paging) {
    return BaseAPIConfig.post(this.controller + "/GetAllUserRoleApp", paging);
  }

  /**
   * lấy dữ liệu nhóm người dùng
   * NVHa1 18/01/2022
   * @param {} userDetail
   * @returns 
   */
  getAllUserGroup(userDetail) {
    return BaseAPIConfig.post(this.controller + "/GetAllUserGroup", userDetail);
  }

  /**
   * lấy danh sách người dùng chưa có trong app
   * pmhieu 2021.08.27
   * @param {} paging 
   * @returns 
   */
  getPagingUserToAdd(paging) {
    return BaseAPIConfig.post("UserRoles" + "/GetPagingUserToAdd", paging);
  }

  /**
   * lưu thông tin người dùng vừa mới thêm
   * pmhieu 2021.08.31
   * @param {} body 
   * @returns 
   */
  saveUserRole(body) {
    return BaseAPIConfig.post(this.controller + "/AddUserInAppV2", body);
  }

  /**
   * sửa thông tin người dùng
   * pmhieu 2021.09.01
   * @param {} body 
   * @returns 
   */
  updateUserRole(body) {
    return BaseAPIConfig.put(this.controller, body);
  }

  /**
   * Lấy danh sách nhóm người dùng
   * NVHa1 24/01/2022
   * @returns 
   */
  getDataGroupUser(){
    return BaseAPIConfig.post(this.controller + "/GetDataGroupUser");
  }

  /**
   * xáo thông tin người dùng
   * pmhieu 2021.09.01
   * @param {} body 
   * @returns 
   */
  deleteUserRole(body) {
    return BaseAPIConfig.post(this.controller + "/remove", body);
  }

  /**
   * Cập nhật Nhóm người dùng
   * NVHa1 21/01/2022
   * @param {} param
   * @returns 
   */
  updateUserGroupOfUser(param) {
    return BaseAPIConfig.post(this.controller + "/UpdateUserGroupOfUser", param);
  }

  /**
   * xáo thông tin người dùng
   * pmhieu 2021.09.01
   * @param {} body 
   * @returns 
   */
  deleteUserInApp(body) {
    return BaseAPIConfig.post(this.controller + "/DeleteUserInApp", body);
  }

}

export default new UserRoleAPI();
